import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import moment from "moment";

import CanvasActions from "../../actions/CanvasActions.js";

import "./style.css";

class Theme extends Component {
  setTheme(color) {
    this.props.setCanvas({
      ...this.props.canvas,
      backgroundColor: color
    });
  }
  render() {
    return (
      <div className="theme-picker">
        <div className="info">
          <p>Pick starmap background color</p>
        </div>
        <div className="theme-picker-row">
          <div
            className={
              this.props.canvas.backgroundColor == "#000"
                ? "theme active"
                : "theme"
            }
            style={{ background: "#000" }}
            onClick={() => {
              this.setTheme("#000");
            }}
          >
            <i className="fa fa-check" />
            <span>Black</span>
          </div>
          <div
            className={
              this.props.canvas.backgroundColor == "#191d29"
                ? "theme active"
                : "theme"
            }
            style={{ background: "#191d29" }}
            onClick={() => {
              this.setTheme("#191d29");
            }}
          >
            <i className="fa fa-check" />
            <span>Midnight Blue</span>
          </div>
          <div
            className={
              this.props.canvas.backgroundColor == "#384656"
                ? "theme active"
                : "theme"
            }
            style={{ background: "#384656" }}
            onClick={() => {
              this.setTheme("#384656");
            }}
          >
            <i className="fa fa-check" />
            <span>Grey Blue</span>
          </div>
          <div
            className={
              this.props.canvas.backgroundColor == "#164b58"
                ? "theme active"
                : "theme"
            }
            style={{ background: "#164b58" }}
            onClick={() => {
              this.setTheme("#164b58");
            }}
          >
            <i className="fa fa-check" />
            <span>Aquamarine</span>
          </div>
          <div
            className={
              this.props.canvas.backgroundColor == "#e7304d"
                ? "theme active"
                : "theme"
            }
            style={{ background: "#e7304d" }}
            onClick={() => {
              this.setTheme("#e7304d");
            }}
          >
            <i className="fa fa-check" />
            <span>Red</span>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    canvas: state.canvas
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCanvas: canvas => {
      dispatch(CanvasActions.setCanvas(canvas));
    }
  };
};

const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(Theme);

export default App;



// WEBPACK FOOTER //
// ./src/components/Theme/index.js